class PredictiveSearch extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('input[type="search"]')
    this.form = this.querySelector('form')
    this.predictiveSearchResults = this.querySelector('#predictive-search')

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event)
    }, 300).bind(this))
    this.form.addEventListener('submit', (event) => {
      this.onSubmit(event)
    })
  }

  onChange() {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.close()
      return
    }

    this.getSearchResults(searchTerm)
  }

  onSubmit(e) {
    e.preventDefault()
    this.form.submit()
  }

  getSearchResults(searchTerm) {
    
    fetch(`/search/suggest?q=${searchTerm}&options%5Bunavailable_products%5D=hide&options%5Bprefix%5D=last&section_id=predictive-search`)
    // fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML
        this.predictiveSearchResults.innerHTML = resultsMarkup
        this.open()
        document.querySelector('.predictive_see_all').setAttribute('href', '/search?q='+searchTerm+'&type=product&options%5Bprefix%5D=last')
      })
      .catch((error) => {
        this.close();
        throw error;
      });
    
    /*
    fetch('/search.json')
      .then(response => response.json())
      .then(data => {
        const term = 'ad'.toLowerCase()
        const filteredProducts = data.products.filter(product => 
          product.title.toLowerCase().includes(term)
        )

        console.log(filteredProducts);
        // Vous pouvez ensuite manipuler ces produits, par exemple en les affichant sur la page
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des produits :', error);
      });
    */
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    const swiper = new Swiper('#predictive-search-results-list .swiper', {
      navigation: {
        prevEl: '#predictive-search-results-nav button:first-of-type',
        nextEl: '#predictive-search-results-nav button:last-of-type',
      },
      breakpoints: {
        0: {
          slidesPerView: 2.3,
          spaceBetween: 16
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    })
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
